<template>
  <div class="vertical-align-wrap">
    <div class="vertical-align-middle">
      <div class="auth-box ">
        <div class="left">
          <div class="content">
            <div class="logo text-center"><img src="../assets/img/logo.png" alt="VDCI Logo"></div>
            <form class="form-auth-small" @submit.prevent="onSubmit({ updateList: false })">
              <div class="form-group">
                <label for="email" class="control-label sr-only">Email</label>
                <input type="email" class="form-control" id="email" v-model="user.email" placeholder="Email" required autofocus>
              </div>

              <loading-button :loading="loading" class="btn btn-primary btn-lg btn-block">Forgot Password</loading-button>

              <div class="bottom">
                <span><i class="fa fa-lock"></i> <router-link :to="{name: 'login'}">Login</router-link></span>
              </div>
            </form>
          </div>
        </div>
        <div class="right">
          <div class="overlay"></div>
          <div class="content text">
            <h1 class="heading">Vector Disease Control International</h1>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import AuthService from '@/services/AuthService';
  import LoadingButton from '@/components/loading-button';

  export default {
    name: 'forgotPassword',

    components: {
      LoadingButton
    },

    data() {
      return {
        loading: false,
        user: {
          email: ''
        }
      }
    },

    methods: {
      onSubmit() {
        this.loading = true;
        AuthService.forgotPassword(this.user.email)
          .then(() => {
            this.loading = false;
            toastr.success('Please check your email for the password reset link.');
          })
          .catch((error) => {
            this.loading = false;
            toastr.error('Sorry, we cannot find your account. Please check your email.');
          })
      }
    }
  }
</script>

<style lang="scss">

</style>